import { render } from "./ReportHistoryTable.vue?vue&type=template&id=67fa18bc"
import script from "./ReportHistoryTable.vue?vue&type=script&lang=js"
export * from "./ReportHistoryTable.vue?vue&type=script&lang=js"
script.render = render

export default script